import getPurchaseServiceLink from './getPurchaseServiceLink';

export default getPurchaseServiceLink;
